import Animate from '../utils/animate';

export default class Video {
    constructor({el}) {
        this.el = el;

        this.bind();

        this.offsetTop = this.getOffsetTop();
    }

    getOffsetTop() {
        let offsetTop = this.el.offsetTop;
        let el = this.el;

        while(el.offsetParent) {
            offsetTop += el.offsetParent.offsetTop; 
            el = el.offsetParent;
        }

        return offsetTop;
    }

    bind() {
        this.el.addEventListener('click', evt => {
            evt.preventDefault();

            Animate(window.scrollY, (this.offsetTop + this.el.clientHeight) - window.scrollY, {
                duration: 500,
                fn: 'easeOutQuad',
                onStep: val => {
                    window.scrollTo(0, val);
                },
                onFinish: () => {
                    this.exiting = false;
                    document.body.classList.add('has-scroll');
                }
            });
            
        });
    }
}
